/* The desktop LAN gateway listens on port 8787 by default.
 * The operator may enter only the server IP (e.g. 192.168.1.20).
 * Preserve explicit ports for upgraded/existing deployments.
 */
export const DEFAULT_LAN_SERVER_PORT = 8787;

export const normalizeLocalServerUrl = (input, defaultPort = DEFAULT_LAN_SERVER_PORT) => {
  const text = String(input ?? '').trim();
  if (!text) return '';
  const withScheme = /^https?:\/\//i.test(text) ? text : `http://${text}`;
  let parsed;
  try { parsed = new URL(withScheme); } catch (_) {
    throw new Error('Enter a valid server IP, for example 192.168.1.20.');
  }
  if (!['http:', 'https:'].includes(parsed.protocol) || !parsed.hostname ||
      parsed.username || parsed.password || parsed.search || parsed.hash ||
      (parsed.pathname !== '/' && parsed.pathname !== '')) {
    throw new Error('Enter only the LAN server IP or host name, without a path or login details.');
  }
  const port = Number(parsed.port || defaultPort);
  if (!Number.isInteger(port) || port < 1 || port > 65535) {
    throw new Error('Invalid server port. Default LAN port is 8787.');
  }
  // URL.hostname also supports bracketed IPv6 addresses.
  const host = parsed.hostname.toLowerCase();
  return `${parsed.protocol}//${host}:${port}`;
};

export const localServerAddressDisplay = (input) => {
  try {
    const normalized = normalizeLocalServerUrl(input);
    if (!normalized) return '';
    const url = new URL(normalized);
    return Number(url.port) === DEFAULT_LAN_SERVER_PORT ? url.hostname : `${url.hostname}:${url.port}`;
  } catch (_) {
    return String(input ?? '');
  }
};

export const checkLanBrowserSecurity = (address) => {
  if (typeof window === 'undefined' || window.location?.protocol !== 'https:') return '';
  const server = normalizeLocalServerUrl(address);
  if (!server || server.startsWith('https:')) return '';
  // Chromium blocks active mixed content from hosted HTTPS pages to HTTP LAN
  // services. Localhost exceptions are browser dependent and not a deployment strategy.
  return 'This page uses HTTPS but the LAN server uses HTTP. Open the React app from the LAN server address (http://SERVER-IP:8787), or configure a trusted HTTPS gateway.';
};
